import _ from 'lodash';

import { getCurrentHost } from '../utils/host/host';

import { AUTOMATION_TESTS_PORT } from './constants';

const DEV_MOCK_API_URL = 'http://localhost:3010';
const TEST_MOCK_API_URL = 'https://media-platform-mock-backend.wix.com';

const EXPERIMENTS_API_PATH =
  '/_api/wix-laboratory-server/laboratory/conductAllInScope?scope=wix-media-platform';

export enum Environment {
  Development = 'Development',
  Testing = 'Testing',
  Production = 'Production',
  e2eTest = 'e2eTest',
  mockedDevelopment = 'mockedDevelopment',
}

export interface Config {
  hosts: {
    paymentServiceOrigin: string;
  };
  api: {
    baseUrl: string;
    biUrl: string;
    mockUrl: string; // Used for temporary not implemented BE services, can be used in staging and prod envs
    experimentsUrl: string;
  };
  keys: {
    googleMapsApiKey: string;
  };
}

const baseConfig = {
  hosts: {
    paymentServiceOrigin: getCurrentHost(),
  },
  api: {
    baseUrl: '/_api',
    biUrl: 'toad.console.wixmp.com',
    mockUrl: TEST_MOCK_API_URL,
    experimentsUrl: `https://www.wix.com${EXPERIMENTS_API_PATH}`,
  },
  keys: {
    googleMapsApiKey: 'AIzaSyAl6PxRvUFWScNOTETQln4Yhq8KH1_4zYQ',
  },
};

const developmentConfig = {
  hosts: {
    paymentServiceOrigin: 'https://console-test.wixmp.com',
  },
  api: {
    baseUrl: 'https://console-test.wixmp.com/_api',
    mockUrl: DEV_MOCK_API_URL,
  },
  keys: {
    googleMapsApiKey: 'AIzaSyAl6PxRvUFWScNOTETQln4Yhq8KH1_4zYQ',
  },
};

const testConfig = {};

const productionConfig = {};

const e2eTestConfig = {
  api: {
    baseUrl: `http://localhost:${AUTOMATION_TESTS_PORT}/_api`,
    biUrl: `//localhost:${AUTOMATION_TESTS_PORT}/bi`,
  },
};

const mockedDevConfig = {
  api: {
    baseUrl: DEV_MOCK_API_URL,
    mockUrl: DEV_MOCK_API_URL,
    experimentsUrl: `${DEV_MOCK_API_URL}${EXPERIMENTS_API_PATH}`,
  },
};

const envConfigOverrides = {
  [Environment.Development]: developmentConfig,
  [Environment.Testing]: testConfig,
  [Environment.Production]: productionConfig,
  [Environment.e2eTest]: e2eTestConfig,
  [Environment.mockedDevelopment]: mockedDevConfig,
};

export function getEnvConfig(env: Environment): Config {
  return _.merge({}, baseConfig, envConfigOverrides[env]);
}
